export type NotificationSeverity = "success" | "info" | "warning" | "error";

export interface Notification {
  message: string;
  severity: NotificationSeverity;
}

type Listener = (notification: Notification) => void;

let listener: Listener | null = null;

/**
 * Registers the host that renders notifications. Called by
 * NotificationProvider; there is only ever one host.
 */
export const setNotificationListener = (next: Listener | null) => {
  listener = next;
};

/**
 * Shows a message to the user.
 *
 * Deliberately a plain module function rather than a hook: reducers,
 * helpers and catch blocks all need to report failures, and none of
 * them run inside a component. Falls back to the console if no host is
 * mounted yet, so a message is never silently swallowed.
 */
export const notify = (
  message: string,
  severity: NotificationSeverity = "info",
) => {
  if (listener) {
    listener({ message, severity });
    return;
  }
  // eslint-disable-next-line no-console
  console[severity === "error" ? "error" : "log"](message);
};
